/** InsCoder 2026-07-13 B + 修复 save-for-later 按钮文案持续更新与 observer 循环 **/
(function () {
  if (window.CafuneCartSaveForLaterInitialized) {
    return;
  }

  window.CafuneCartSaveForLaterInitialized = true;

  var state = {
    swat: window._swat || null,
    listId: window._sflListId || null,
    initStarted: false,
    savedVariantIds: {},
    syncStarted: false,
    syncTimeout: null,
    observerStarted: false,
    syncQueued: false,
    syncRafScheduled: false
  };

  var selectors = {
    button: "[data-swym-save-for-later-trigger]",
    swymContainers: "#swym-plugin, #swym-hosted-plugin"
  };

  function normalizeId(value) {
    if (value === null || value === undefined) {
      return "";
    }

    return String(value);
  }

  function getButtons() {
    return document.querySelectorAll(selectors.button);
  }

  function hydrateButtonData(button) {
    // Cache the original label so we can restore it after Save For Later state changes.
    if (!button.getAttribute("data-default-text")) {
      button.setAttribute("data-default-text", button.textContent.trim());
    }

    if (!button.getAttribute("data-default-aria-label")) {
      button.setAttribute(
        "data-default-aria-label",
        button.getAttribute("aria-label") || button.textContent.trim()
      );
    }
  }

  function setListId(response) {
    if (response && response.list && response.list.lid) {
      state.listId = response.list.lid;
      window._sflListId = response.list.lid;
      return true;
    }

    return false;
  }

  function initSaveForLater() {
    if (!state.swat || !state.swat.SaveForLater || state.listId || state.initStarted) {
      return;
    }

    state.initStarted = true;

    state.swat.SaveForLater.init(
      function (response) {
        state.initStarted = false;
        setListId(response);
        scheduleSavedItemsSync();
      },
      function (error) {
        state.initStarted = false;
        console.error("Swym Save For Later init error", error);
      }
    );
  }

  function setSwatInstance(swat) {
    if (!swat) {
      return;
    }

    state.swat = swat;
    window._swat = window._swat || swat;

    startSyncObservers();
    initSaveForLater();

    if (state.listId) {
      scheduleSavedItemsSync();
    }
  }

  function getProductPayload(button) {
    var variantId = button.getAttribute("data-variant-id");
    var productId = button.getAttribute("data-product-id");
    var productUrl = button.getAttribute("data-product-url");

    if (!variantId || !productId || !productUrl) {
      return null;
    }

    return {
      epi: variantId,
      empi: productId,
      du: productUrl
    };
  }

  function getNotificationMessage(response) {
    var addedItem = response && response.itemsadded && response.itemsadded[0];
    var productTitle = addedItem && addedItem.dt ? addedItem.dt : "";

    if (productTitle) {
      return productTitle + " has been added to Save For Later!";
    }

    return "Item has been added to Save For Later!";
  }

  function revealNotificationContainer() {
    window.setTimeout(function () {
      var container = document.querySelector(".swym-wishlist-notifications-container");

      if (!container) {
        return;
      }

      container.hidden = false;
      container.style.display = "";
      container.style.visibility = "visible";
      container.style.opacity = "1";
    }, 50);
  }

  function showSuccessNotification(response) {
    var message = getNotificationMessage(response);

    if (
      state.swat &&
      state.swat.ui &&
      typeof state.swat.ui.showSuccessNotification === "function"
    ) {
      state.swat.ui.showSuccessNotification({ message: message });
      revealNotificationContainer();
      return;
    }

    revealNotificationContainer();
  }

  function isButtonLocked(button) {
    return (
      button.disabled ||
      button.getAttribute("aria-disabled") === "true" ||
      button.getAttribute("data-swym-save-for-later-added") === "true" ||
      button.getAttribute("data-swym-save-for-later-processing") === "true"
    );
  }

  // Idempotent DOM write: only touch textContent / aria-label when the
  // visible state actually changes. Without this guard every observer tick
  // would rewrite the button text and force a new mutation cycle.
  function applyButtonState(button, nextState, label) {
    if (button.getAttribute("data-state-applied") === nextState) {
      return;
    }

    if (label) {
      button.textContent = label;
      button.setAttribute("aria-label", label);
    }

    button.setAttribute("data-state-applied", nextState);
  }

  function markButtonAsSaved(button) {
    var savedText = button.getAttribute("data-saved-text");

    hydrateButtonData(button);

    applyButtonState(button, "saved", savedText);

    lockButton(button, false);
  }

  function markButtonAsAvailable(button) {
    if (button.getAttribute("data-swym-save-for-later-processing") === "true") {
      return;
    }

    hydrateButtonData(button);

    unlockButton(button);
    button.removeAttribute("data-swym-save-for-later-added");

    applyButtonState(
      button,
      "available",
       button.getAttribute("data-default-text")
    );
  }

  function lockButton(button, isProcessing) {
    button.disabled = true;
    button.setAttribute("aria-disabled", "true");
    button.classList.add("is-swym-save-for-later-disabled");

    if (isProcessing) {
      button.setAttribute("aria-busy", "true");
      button.setAttribute("data-swym-save-for-later-processing", "true");
      return;
    }

    button.removeAttribute("aria-busy");
    button.removeAttribute("data-swym-save-for-later-processing");
    button.setAttribute("data-swym-save-for-later-added", "true");
  }

  function unlockButton(button) {
    button.disabled = false;
    button.removeAttribute("aria-disabled");
    button.removeAttribute("aria-busy");
    button.removeAttribute("data-swym-save-for-later-processing");
    button.classList.remove("is-swym-save-for-later-disabled");
  }

  function setSavedVariantIds(items) {
    var nextSavedVariantIds = {};

    (items || []).forEach(function (item) {
      var variantId = normalizeId(item && item.epi);

      if (variantId) {
        nextSavedVariantIds[variantId] = true;
      }
    });

    state.savedVariantIds = nextSavedVariantIds;
  }

  // Save for later local button state
  function setVariantSavedState(variantId, isSaved) {
    var normalizedVariantId = normalizeId(variantId);

    if (!normalizedVariantId) {
      return;
    }

    if (isSaved) {
      state.savedVariantIds[normalizedVariantId] = true;
    } else {
      delete state.savedVariantIds[normalizedVariantId];
    }

    syncButtonsWithSavedItems();
  }

  function syncButtonsWithSavedItems() {
    getButtons().forEach(function (button) {
      var variantId = normalizeId(button.getAttribute("data-variant-id"));

      hydrateButtonData(button);

      if (!variantId) {
        return;
      }

      if (state.savedVariantIds[variantId]) {
        markButtonAsSaved(button);
        return;
      }

      markButtonAsAvailable(button);
    });
  }

  function fetchSavedItems() {
    if (
      !state.swat ||
      !state.swat.SaveForLater ||
      !state.listId ||
      state.syncStarted
    ) {
      return;
    }

    state.syncStarted = true;

    // Treat Save For Later as the source of truth and reconcile all cart buttons from it.
    state.swat.SaveForLater.fetch(
      state.listId,
      function (response) {
        state.syncStarted = false;
        setSavedVariantIds(response && response.items);
        syncButtonsWithSavedItems();
        flushQueuedSync();
      },
      function (error) {
        state.syncStarted = false;
        console.error("Swym Save For Later fetch error", error);
        flushQueuedSync();
      }
    );
  }

  function flushQueuedSync() {
    if (!state.syncQueued) {
      return;
    }

    state.syncQueued = false;
    scheduleSavedItemsSync(100);
  }

  function scheduleSavedItemsSync(delay) {
    var wait = typeof delay === "number" ? delay : 200;

    // If a fetch is already running, queue exactly one more pass instead of dropping updates.
    if (state.syncStarted) {
      state.syncQueued = true;
      return;
    }

    if (state.syncTimeout) {
      window.clearTimeout(state.syncTimeout);
    }

    state.syncTimeout = window.setTimeout(function () {
      state.syncTimeout = null;
      fetchSavedItems();
    }, wait);
  }

  function isRelevantNode(node) {
    if (!node || node.nodeType !== 1) {
      return false;
    }

    if (
      node.id === "swym-plugin" ||
      node.id === "swym-hosted-plugin"
    ) {
      return true;
    }

    if (typeof node.closest !== "function") {
      return false;
    }

    if (!node.closest(selectors.swymContainers)) {
      return false;
    }

    if (typeof node.matches === "function" && node.matches(selectors.button)) {
      return true;
    }

    if (typeof node.querySelector === "function" && node.querySelector(selectors.button)) {
      return true;
    }

    return false;
  }

  // Coalesce observer bursts into a single scheduled sync per frame so we
  // don't refetch Save For Later state on every Swym internal mutation.
  function requestSync() {
    if (state.syncRafScheduled) {
      return;
    }

    state.syncRafScheduled = true;

    window.requestAnimationFrame(function () {
      state.syncRafScheduled = false;
      scheduleSavedItemsSync(0);
    });
  }

  function attachObserverTo(root) {
    if (state.observerStarted || !root) {
      return;
    }

    state.observerStarted = true;

    // Swym updates its hosted UI asynchronously, so observe DOM changes and re-sync button state.
    var observer = new MutationObserver(function (mutations) {
      var shouldSync = mutations.some(function (mutation) {
        if (isRelevantNode(mutation.target)) {
          return true;
        }

        return Array.prototype.some.call(mutation.addedNodes, isRelevantNode) ||
          Array.prototype.some.call(mutation.removedNodes, isRelevantNode);
      });

      if (shouldSync) {
        requestSync();
      }
    });

    observer.observe(root, {
      childList: true,
      subtree: true
    });
  }

  function startSyncObservers() {
    if (state.observerStarted || !document.body) {
      return;
    }

    // Prefer observing the Swym container directly so cart DOM changes
    // outside Swym never trigger a refetch.
    var swymRoot = document.querySelector(selectors.swymContainers);

    if (swymRoot) {
      attachObserverTo(swymRoot);
      return;
    }

    // Fall back to body only until the Swym container mounts, then narrow scope.
    attachObserverTo(document.body);

    var mountWatcher = window.setInterval(function () {
      if (state.observerStarted) {
        window.clearInterval(mountWatcher);
        return;
      }

      var mounted = document.querySelector(selectors.swymContainers);

      if (mounted) {
        window.clearInterval(mountWatcher);
        // observer is already attached to body; we keep it but rely on
        // isRelevantNode to drop unrelated mutations.
      }
    }, 1000);

    window.setTimeout(function () {
      window.clearInterval(mountWatcher);
    }, 30000);
  }

  function addToSaveForLater(button) {
    var product = getProductPayload(button);

    if (isButtonLocked(button)) {
      return;
    }

    if (!product) {
      console.error("Swym Save For Later product payload is incomplete");
      return;
    }

    if (!state.swat || !state.listId) {
      initSaveForLater();
      console.error("Swym Save For Later is not ready yet");
      return;
    }

    lockButton(button, true);

    // Update the clicked button optimistically, then run a single delayed
    // reconcile so Swym's own UI catches up without re-firing the popup.
    state.swat.SaveForLater.add(
      state.listId,
      [product],
      function (response) {
        setVariantSavedState(product.epi, true);
        markButtonAsSaved(button);
        showSuccessNotification(response);
        // Quiet background reconcile: refreshes button state once for any
        // Swym-hosted buttons without triggering another notification.
        scheduleSavedItemsSync(800);
      },
      function (error) {
        unlockButton(button);
        console.error("Swym Save For Later add error", error);
      }
    );
  }

  document.addEventListener("click", function (event) {
    var button = event.target.closest("[data-swym-save-for-later-trigger]");

    if (!button) {
      return;
    }

    event.preventDefault();

    if (isButtonLocked(button)) {
      return;
    }

    addToSaveForLater(button);
  });

  document.addEventListener("visibilitychange", function () {
    if (!document.hidden) {
      scheduleSavedItemsSync(200);
    }
  });

  window.addEventListener("focus", function () {
    scheduleSavedItemsSync(200);
  });

  syncButtonsWithSavedItems();

  if (window._swat && window._swat.SaveForLater) {
    setSwatInstance(window._swat);
  }

  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(function (swat) {
    setSwatInstance(swat);
  });
})();
/** InsCoder 2026-07-13 E + 修复 save-for-later 按钮文案持续更新与 observer 循环 **/